import React from 'react'

import Login from '../pages/auth/Login'
import ForgotPassword from "../pages/auth/ForgotPassword"

import Wms from '../pages/main/wms/Index'
import Pos from '../pages/main/pos/Index'
import Units from '../pages/main/units/Index'
import Clients from '../pages/main/clients/Index'
import ClientTypes from '../pages/main/clientTypes/Index'
import Employees from '../pages/main/employees/Index'
import EmployeesTypes from '../pages/main/employeesTypes/Index'
import Roles from '../pages/main/roles/Index'
import Departments from '../pages/main/departments/Index'
import EmployeeAccount from '../pages/main/employees/Account'
import Kpi from '../pages/main/employees/Kpi'
import Attendance from '../pages/main/attendance/Index'
import Currency from '../pages/main/currency/Index'
import Suppliers from '../pages/main/suppliers/Index'
import Categories from '../pages/main/categories/Index'
import Accounts from '../pages/main/accounts/Index'
import DeliveryTypes from '../pages/main/deliveryTypes/Index'
import PaymentTypes from '../pages/main/paymentTypes/Index'
import PaymentPurposes from '../pages/main/paymentPurposes/Index'
import PaymentPurposeGroups from '../pages/main/paymentPurposeGroups/Index'
import TelegramSettings from '../pages/main/telegramSettings/Index'
import SmsSettings from '../pages/main/smsSettings/Index'
import HikvisionDevices from '../pages/main/hikvision/Index'
import AttendanceSetup from '../pages/main/attendanceSetup/Index'
import CrmSettings from '../pages/main/crmSettings/Index'
import ChequeNoteSettings from '../pages/main/chequeNoteSettings/Index'
import UrgentSettings from '../pages/main/urgentSettings/Index'
import Complaints from '../pages/main/complaints/Index'
import Regions from '../pages/main/regions/Index'

import CashboxCheques from '../pages/main/cashbox/Index'
import Cashbox from '../pages/main/cashbox/Cashbox'
import PendingOrders from '../pages/main/cashbox/PendingOrders'
import CashboxMenu from '../pages/main/cashbox/Menu'

import WorkShopCheques from '../pages/workshop/cheques/Index'
import WorkshopDashboard from '../pages/workshop/dashboard/Index'
import WorkshopReport from '../pages/workshop/report/Index'
import WarehouseCheques from '../pages/workshop/warehouse/Index'
import Board from '../pages/workshop/Board'

import Product from '../pages/main/products/Index'
import ProductCreateUpdate from '../pages/main/products/CreateUpdate'
import ProductStatuses from '../pages/main/productsGroupStatus/Index'

import DocumentsIn from '../pages/main/documentsIn/Index'
import DocumentsInCreateUpdate from '../pages/main/documentsIn/CreateUpdate'
import DocumentsInPreview from '../pages/main/documentsIn/Preview'

import DocumentPreparation from '../pages/main/documentsPreparation/Index'
import DocumentPreparationCreateUpdate from '../pages/main/documentsPreparation/CreateUpdate'
import DocumentPreparationPreview from '../pages/main/documentsPreparation/Preview'

import WorkshopDocumentPreparation from '../pages/workshop/documentsPreparation/Index'
import WorkshopDocumentPreparationCreateUpdate from '../pages/workshop/documentsPreparation/CreateUpdate'
import WorkshopDocumentPreparationPreview from '../pages/workshop/documentsPreparation/Preview'
import DailyWork from '../pages/workshop/DailyWork'

import WriteOff from '../pages/main/writeOff/Index'
import WriteOffCreateUpdate from '../pages/main/writeOff/CreateUpdate'
import WriteOffPreview from '../pages/main/writeOff/Preview'

import Inventory from '../pages/main/inventory/Index'
import InventoryCreateUpdate from '../pages/main/inventory/CreateUpdate'
import InventoryPreview from '../pages/main/inventory/Preview'

// Analytics
import AnalyticsDashboard from '../pages/main/analytics/Dashboard'
import DailyDashboard from '../pages/main/analytics/DailyDashboard'
import AnalyticsUnit from '../pages/main/analytics/Unit'
import ExpenseAnalysis from '../pages/main/analytics/ExpenseAnalysis'
import MonthlyReport from '../pages/main/analytics/MonthlyReport'
import CustomerAnalytics from '../pages/main/analytics/CustomerAnalytics'
import AbcProducts from '../pages/main/analytics/AbcProducts'
import Reorder from '../pages/main/analytics/Reorder'
import Frozen from '../pages/main/analytics/Frozen'
import AbcXyz from '../pages/main/analytics/AbcXyz'
import VideoAnalytics from '../pages/main/analytics/VideoAnalytics'
import ProductionCapacity from '../pages/main/productionCapacity/Index'

// Reports
import Dashboard from '../pages/main/reports/Dashboard'
import ReportClients from '../pages/main/reports/ClientDebt'
import ReportClientsInnerDebts from '../pages/main/reports/ClientDebtInner'
import ReportSuppliers from '../pages/main/reports/Supplier'
import ReportSuppliersInner from '../pages/main/reports/SupplierInnerDebt'
import StockLevels from '../pages/main/warehouse/StockLevels'
import SupplierOrders from '../pages/main/warehouse/SupplierOrders'
import ReportBalance from '../pages/main/reports/Balance'
import ReportBalance2 from '../pages/main/reports/Balance2'
import Shifts from 'pages/main/reports/Shifts'
import ManagerReports from 'pages/main/reports/ManagerReports'
import ZReport from 'pages/main/reports/ZReport'
import DcoumentsIn from 'pages/main/reports/DocumentsIn'
import Summary from 'pages/main/reports/Summary'
import Expenses from 'pages/main/reports/Expenses'
import Rasxodlar from 'pages/main/reports/Rasxodlar'
import ReportGrossIncome from 'pages/main/reports/GrossIncome'
import DeletedCheques from 'pages/main/reports/DeletedCheques'
import DeletedExpenses from 'pages/main/reports/DeletedExpenses'
import ReturnsReport from 'pages/main/reports/ReturnsReport'
import DebtMonitoring from 'pages/main/reports/DebtMonitoring'

// ADMIN
import AdminPos from '../pages/admin/pos/Index'
import AdminUser from '../pages/admin/users/Index'
import AdminPayment from '../pages/admin/payments-history/Index'
import DocumentsPreparation from 'pages/main/reports/DocumentsPreparation'
import Sales from 'pages/main/reports/Sales'
import Cashiers from 'pages/main/reports/Cashiers'
import RollProfit from 'pages/main/reports/RollProfit'
import RollPrices from 'pages/main/reports/RollPrices'
import RollWarehouse from 'pages/main/reports/RollWarehouse'
import AccessoryDrawings from 'pages/main/accessoryDrawings/Index'

export const publicRoutes = [
	{ path: "/auth/login", component: <Login /> },
	{ path: "/auth/forgot-password", component: <ForgotPassword /> },
]

export const cashierRoutes = [
	{ path: "/cashbox", component: <CashboxCheques /> },

	{ path: "/cashbox/create", component: <Cashbox /> },
	{ path: "/cashbox/edit/:id", component: <Cashbox /> },
	{ path: "/cashbox/pending-orders", component: <PendingOrders /> },
	{ path: "/cashbox/menu", component: <CashboxMenu /> },
	{ path: "/cashbox/asosiy", component: <Dashboard /> },
	{ path: "/cashbox/kirim-chiqim", component: <Expenses /> },
	{ path: "/cashbox/rasxodlar", component: <Rasxodlar /> },
	{ path: "/cashbox/returns", component: <ReturnsReport /> },
	{ path: "/cashbox/deleted-cheques", component: <DeletedCheques /> },
	{ path: "/cashbox/deleted-expenses", component: <DeletedExpenses /> },
	// Xodimlar hisob-kitobi — egasidagi bilan AYNAN BIR XIL sahifa.
	// Ko'rinish ruxsat galochkasi bilan boshqariladi (`cashbox.employee_account`),
	// backend ham shu ruxsatni tekshiradi.
	{ path: "/cashbox/employee-account", component: <EmployeeAccount /> },
	/* AKSESSUAR CHIZMALARI — sotuvchiga galochka bilan beriladi
	   (`cashbox.accessory_drawings` + tarif `sec.accessory_drawing`).
	   Ega uchun bu sahifa `/accessory-drawings` da (owner menyusi), kassir
	   maketida esa «Бўлимлар» ro'yxatidan ochiladi. Komponent BIR XIL. */
	{ path: "/cashbox/accessory-drawings", component: <AccessoryDrawings /> },
	{ path: "/production-board", component: <Board /> },
]

export const workshopRoutes = [
	{ path: "/workshop", component: <WorkShopCheques /> },
	{ path: "/workshop/board", component: <Board /> },
	/* Shikoyatlar — ishlab chiqarish rahbari (HR) uchun. Backend qo'riqchisi
	   (`hr:cashbox.complaints`) bu rolni allaqachon o'tkazadi, lekin yo'l shu
	   ro'yxatda bo'lmagani uchun sahifa ochilmay /workshop ga qaytarilardi. */
	{ path: "/complaints", component: <Complaints />, permission: "sec.complaints" },
	// KADRLAR — ishlab chiqarish rahbari va HR uchun.
	// Backendда `hr` middleware bilan himoyalangan (rol darajasida), shuning uchun
	// bu yerda ochilgani bilan kassir/usta/omborchi ma'lumot ololmaydi.
	// ⚠️ Bu yo'llar privateRoutes da HAM bor — routes/index.js egaga ularni
	// o'tkazib yuboradi, aks holda ega sex layoutini olib qolardi.
	{ path: "/employees", component: <Employees /> },
	{ path: "/employee-account", component: <EmployeeAccount /> },
	{ path: "/kpi", component: <Kpi /> },
	{ path: "/attendance", component: <Attendance /> },
	{ path: "/attendance-setup", component: <AttendanceSetup /> },
	// Davomat sozlamasidagi «Boshqarish» tugmasi shu yerga olib keladi
	{ path: "/hikvision-devices", component: <HikvisionDevices /> },
	{ path: "/employees-types", component: <EmployeesTypes /> },
	{ path: "/departments", component: <Departments /> },
	{ path: "/workshop/dashboard", component: <WorkshopDashboard /> },
	{ path: "/workshop/report", component: <WorkshopReport /> },
	{ path: "/workshop/daily-work", component: <DailyWork /> },
	{ path: "/warehouse", component: <WarehouseCheques /> },

	{ path: "/workshop/documents-preparation", component: <WorkshopDocumentPreparation /> },
	{ path: "/workshop/documents-preparation/create", component: <WorkshopDocumentPreparationCreateUpdate /> },
	{ path: "/workshop/documents-preparation/preview/:id", component: <WorkshopDocumentPreparationPreview /> },
	/* ═══ OMBORCHI (ROLE_WAREHOUSE) — 2026-08-24 ═══
	   Ilgari omborchi menyuda ATIGI 2 band ko'rardi (Кенгаш va «chiqarishga
	   tayyor cheklar») va ombor ekranlarining BIRORTASIGA ham kira olmasdi:
	   qabul, tayyorlash, inventarizatsiya, qoldiq — hammasi faqat egada edi.
	   Bu yo'llar privateRoutes da HAM bor; routes/index.js egaga takrorni
	   o'tkazib yuboradi (aynan /employees uchun ishlangan naqsh). */
	{ path: "/stock-levels", component: <StockLevels /> },
	{ path: "/supplier-orders", component: <SupplierOrders /> },
	{ path: "/warehouse-finished", component: <ReportBalance key="wh-finished-wh" warehouse="finished" titleKey="warehouse_finished" /> },
	{ path: "/report-balance", component: <ReportBalance key="balance-wh" /> },
	{ path: "/documents-preparation", component: <DocumentPreparation /> },
	{ path: "/documents-preparation/create", component: <DocumentPreparationCreateUpdate /> },
	{ path: "/documents-preparation/preview/:id", component: <DocumentPreparationPreview /> },
	{ path: "/write-off", component: <WriteOff /> },
	{ path: "/write-off/create", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/update/:id", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/preview/:id", component: <WriteOffPreview /> },
	{ path: "/inventory", component: <Inventory /> },
	{ path: "/inventory/create", component: <InventoryCreateUpdate /> },
	{ path: "/inventory/update/:id", component: <InventoryCreateUpdate /> },
	{ path: "/inventory/preview/:id", component: <InventoryPreview /> },
]

export const privateRoutes = [
	{ path: "/pos", component: <Pos /> },
	{ path: "/wms", component: <Wms /> },
	{ path: "/units", component: <Units /> },
	{ path: "/clients", component: <Clients /> },
	{ path: "/clients-types", component: <ClientTypes /> },
	{ path: "/employees", component: <Employees /> },
	{ path: "/employees-types", component: <EmployeesTypes /> },
	{ path: "/roles", component: <Roles /> },
	{ path: "/departments", component: <Departments /> },
	{ path: "/employee-account", component: <EmployeeAccount /> },
	{ path: "/kpi", component: <Kpi /> },
	{ path: "/attendance", component: <Attendance /> },
	{ path: "/categories", component: <Categories /> },
	{ path: "/accounts", component: <Accounts /> },
	{ path: "/delivery-types", component: <DeliveryTypes /> },
	{ path: "/suppliers", component: <Suppliers /> },
	{ path: "/currency", component: <Currency /> },
	{ path: "/payment-types", component: <PaymentTypes /> },
	{ path: "/payment-purposes", component: <PaymentPurposes /> },
	{ path: "/payment-purpose-groups", component: <PaymentPurposeGroups /> },
	{ path: "/telegram-settings", component: <TelegramSettings /> },
	{ path: "/sms-settings", component: <SmsSettings />, permission: "sec.broadcast" },
	{ path: "/hikvision-devices", component: <HikvisionDevices /> },
	{ path: "/attendance-setup", component: <AttendanceSetup /> },
	{ path: "/crm-settings", component: <CrmSettings /> },
	{ path: "/cheque-note-settings", component: <ChequeNoteSettings /> },
	{ path: "/urgent-settings", component: <UrgentSettings /> },
	{ path: "/complaints", component: <Complaints />, permission: "sec.complaints" },
	// Sotuvchi maketi (Kassa -> Bo'limlar) uchun AYNI sahifa — ikki nusxa kod bo'lmasin
	{ path: "/cashbox/complaints", component: <Complaints /> },
	{ path: "/regions", component: <Regions /> },

	{ path: "/products", component: <Product /> },
	{ path: "/production-capacity", component: <ProductionCapacity /> },
	{ path: "/products/create", component: <ProductCreateUpdate /> },
	{ path: "/products/update/:id", component: <ProductCreateUpdate /> },
	{ path: "/product-statuses", component: <ProductStatuses /> },

	{ path: "/documents-in", component: <DocumentsIn /> },
	{ path: "/documents-in/create", component: <DocumentsInCreateUpdate /> },
	{ path: "/documents-in/preview/:id", component: <DocumentsInPreview /> },

	{ path: "/documents-preparation", component: <DocumentPreparation /> },
	{ path: "/documents-preparation/create", component: <DocumentPreparationCreateUpdate /> },
	{ path: "/documents-preparation/preview/:id", component: <DocumentPreparationPreview /> },

	{ path: "/write-off", component: <WriteOff /> },
	{ path: "/write-off/create", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/update/:id", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/preview/:id", component: <WriteOffPreview /> },

	{ path: "/inventory", component: <Inventory /> },
	{ path: "/inventory/create", component: <InventoryCreateUpdate /> },
	{ path: "/inventory/update/:id", component: <InventoryCreateUpdate /> },
	{ path: "/inventory/preview/:id", component: <InventoryPreview /> },

	{ path: "/production-board", component: <Board /> },

	{ path: "/analytics/dashboard", component: <AnalyticsDashboard />, permission: "sec.analytics_dashboard" },
	{ path: "/analytics/unit", component: <AnalyticsUnit />, permission: "sec.analytics_unit" },
	{ path: "/analytics/expenses", component: <ExpenseAnalysis />, permission: "sec.analytics_expenses" },
	{ path: "/analytics/monthly-report", component: <MonthlyReport />, permission: "sec.analytics_monthly_report" },
	{ path: "/analytics/customer", component: <CustomerAnalytics />, permission: "sec.analytics_customer" },
	{ path: "/analytics/abc-products", component: <AbcProducts />, permission: "sec.analytics_abc_products" },
	{ path: "/analytics/reorder", component: <Reorder />, permission: "sec.analytics_reorder" },
	{ path: "/analytics/frozen", component: <Frozen />, permission: "sec.analytics_frozen" },
	{ path: "/analytics/abc-xyz", component: <AbcXyz />, permission: "sec.analytics_abc_xyz" },
	{ path: "/analytics/daily-dashboard", component: <DailyDashboard />, permission: "sec.analytics_daily_dashboard" },
	{ path: "/analytics/video", component: <VideoAnalytics />, permission: "sec.analytics_video" },

	{ path: "/report/dashboard", component: <Dashboard /> },
	{ path: "/report/shifts", component: <Shifts /> },
	{ path: "/report/manager-reports", component: <ManagerReports /> },
	{ path: "/report/z-report", component: <ZReport /> },
	{ path: "/report/documents-in", component: <DcoumentsIn /> },
	{ path: "/report/documents-preparation", component: <DocumentsPreparation /> },
	{ path: "/report/sales", component: <Sales /> },
	{ path: "/report/cashiers", component: <Cashiers /> },
	{ path: "/report/summary", component: <Summary /> },
	{ path: "/report/expenses", component: <Expenses /> },
	{ path: "/report/rasxodlar", component: <Rasxodlar /> },
	{ path: "/report/gross-income", component: <ReportGrossIncome /> },
	{ path: "/report/roll-profit", component: <RollProfit /> },
	{ path: "/report/roll-prices", component: <RollPrices /> },
	{ path: "/cashbox/pending-orders", component: <PendingOrders /> },
	{ path: "/report/deleted-cheques", component: <DeletedCheques /> },
	{ path: "/report/deleted-expenses", component: <DeletedExpenses /> },
	{ path: "/report/returns", component: <ReturnsReport /> },

	{ path: "/report-suppliers", component: <ReportSuppliers /> },
	{ path: "/report-suppliers-debts/:supplier_id", component: <ReportSuppliersInner /> },
	{ path: "/report-clients", component: <ReportClients /> },
	{ path: "/report-clients-debts/:client_id", component: <ReportClientsInnerDebts /> },
	{ path: "/report/debt-monitoring", component: <DebtMonitoring /> },
	{ path: "/report-balance", component: <ReportBalance key="balance-all" /> },
	{ path: "/report-balance-2", component: <ReportBalance2 /> },
	{ path: "/warehouse-rolls", component: <RollWarehouse /> },
	// Standart aksessuar chizmalari — mahsulotga biriktiriladi, sotuvda o'zi chiqadi
	{ path: "/accessory-drawings", component: <AccessoryDrawings /> },
	{ path: "/warehouse-products", component: <ReportBalance key="wh-products" warehouse="products" titleKey="warehouse_products" /> },
	{ path: "/warehouse-finished", component: <ReportBalance key="wh-finished" warehouse="finished" titleKey="warehouse_finished" /> },
	{ path: "/stock-levels", component: <StockLevels /> },
	{ path: "/supplier-orders", component: <SupplierOrders /> },

]

export const adminPrivateRoutes = [
	// admin
	{ path: "/admin/users", component: <AdminUser /> },
	{ path: "/admin/poses", component: <AdminPos /> },
	{ path: "/admin/payments-history", component: <AdminPayment /> },
]